import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Tables from "./pages/Bookings";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Landing from "./pages/Landing";
import AirportTransfers from "./pages/AirportTransfers";
import VehicleRentals from "./pages/VehicleRentals";
import TourismPackages from "./pages/TourismPackages";
import { LoadScript } from "@react-google-maps/api";
import { useContext, useEffect, useState } from "react";
import Bookings from "./pages/Bookings";
import VehiclesType from "./pages/VehiclesType";
import Vehicles from './pages/Vehicles';
import Users from "./pages/Users";
import Airports from "./pages/Airports";
import Drivers from "./pages/Drivers";
import Appointments from "./pages/Appointments";
import TourPackages from "./pages/TourPackages";
import Customers from "./pages/Customers";
import Addons from "./pages/Addons";
import RentalBookings from "./pages/RentalBookings";
import TourBookings from "./pages/TourBookings";
import Confirmation from "./pages/Confirmation";
import PrivateRoute from "./context/PrivateRoute";
import { AuthContext, AuthProvider } from "./context/Auth";
import ConfirmationRental from "./pages/ConfirmationRental";
import ConfirmationTour from "./pages/ConfirmationTour";
import Accounts from "./pages/Accounts";
import { CurrencyProvider } from "./context/CurrencyContext";
import { useLocation } from 'react-router-dom';
import { notification } from "antd";
import { onMessageListener, requestForToken } from "./firebase";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";
import ContactUs from "./pages/ContactUs";
import GdprPolicy from "./pages/GdprPolicy";
import Roles from "./pages/Roles";
import useNotificationListener from "./useNotificationListener";
import DiscountCodes from "./pages/DiscountCodes";
import Settings from "./pages/Settings";
import { getSettingDetail } from "./api/discount.service";
import {useHistory} from 'react-router-dom'
import Dashboard from "./pages/Dashboard";
import config from './config';
import { addNotification } from "./api/notification.service";

const libraries = ["places"];
function App() {
  const history = useHistory();

  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout()
  }

  useNotificationListener();
  const { pathname } = useLocation();

  const [apiKey, setApiKey] = useState(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  useEffect(() => {
    if (localStorage.getItem('token')) {

      let user = JSON.parse(localStorage.getItem("user"))
      requestForToken(user?.role);

      onMessageListener().then(async (payload) => {
        // Play notification sound
        const audio = new Audio('/notification.wav');  // Assuming you have notification.wav in public folder
        audio.play().catch(err => console.log('Error playing sound:', err));
        
        const newNotification = {
          title: payload.notification.title,
          body: payload.notification.body,
          timestamp: new Date().toISOString(),
          unread: true, // New notifications are unread by default
        };

        try {
          // Save notification to API instead of localStorage
          await addNotification(newNotification);
          
          // Trigger event for real-time update
          window.dispatchEvent(new Event("storage"));
        } catch (error) {
          console.error('Error saving notification:', error);
        }

        // Show notification
        notification.info({
          message: payload.notification.title,
          description: payload.notification.body,
        });

        if(newNotification.title=='Role permissions updated'){
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            history.push("/sign-in");
        }
      });
    }
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getSettingDetail();
        const data = await response?.data;
        setApiKey(data.googleMapKey); // Set the API key to state
      } catch (error) {
        console.error('Error fetching the API key:', error);
      }
    };

    fetchSettings();
  }, []);

  if (!apiKey) {
    return <div>Loading...</div>;
  }

  return (
    <LoadScript
      googleMapsApiKey={apiKey || config.GOOGLE_MAPS_API_KEY || ""}
      libraries={libraries}
    >
      <div className="App">
        <AuthProvider>
          <CurrencyProvider>
            <Switch>
              <Route path="/" exact component={Landing} />
              <Route path="/airport-transfers" exact component={AirportTransfers} />
              <Route path="/vehicle-rentals" exact component={VehicleRentals} />
              <Route path="/tourism-packages" exact component={TourismPackages} />
              <Route path="/confirmation" exact component={Confirmation} />
              <Route path="/confirmation-rental" exact component={ConfirmationRental} />
              <Route path="/confirmation-tour" exact component={ConfirmationTour} />
              <Route path="/sign-in" exact component={SignIn} />
              <Route path="/about-us" exact component={AboutUs} />
              <Route path="/privacy-policy" exact component={PrivacyPolicy} />
              <Route path="/terms-and-conditions" exact component={TermsAndCondition} />
              <Route path="/contact-us" exact component={ContactUs} />
              <Route path="/gdpr-policy" exact component={GdprPolicy} />
              <Main>
                <PrivateRoute exact path="/overview" component={Dashboard} />
                <PrivateRoute exact path="/airport-bookings" component={Bookings} />
                <PrivateRoute exact path="/rental-bookings" component={RentalBookings} />
                <PrivateRoute exact path="/tour-bookings" component={TourBookings} />
                <PrivateRoute exact path="/vehicles" component={Vehicles} />
                <PrivateRoute exact path="/vehicles-type" component={VehiclesType} />
                <PrivateRoute exact path="/airports" component={Airports} />
                <PrivateRoute exact path="/users" component={Users} />
                <PrivateRoute exact path="/drivers" component={Drivers} />
                <PrivateRoute exact path="/profile" component={Profile} />
                <PrivateRoute exact path="/tours/:id?" component={TourPackages} />
                <PrivateRoute exact path="/customers" component={Customers} />
                <PrivateRoute exact path="/appointments" component={Appointments} />
                <PrivateRoute exact path="/addons" component={Addons} />
                <PrivateRoute exact path="/accounts" component={Accounts} />
                <PrivateRoute exact path="/roles" component={Roles} />
                <PrivateRoute exact path="/discount-codes" component={DiscountCodes} />
                <PrivateRoute exact path="/settings" component={Settings} />
                {/* <Redirect from="*" to="/airport-bookings" /> */}
              </Main>
            </Switch>
          </CurrencyProvider>
        </AuthProvider>
      </div>
    </LoadScript>
  );
}

export default App;
